import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  title: {
    textTransform: props => props.transform,
    '&:not(:first-child)': {
      marginTop: theme.spacing(2)
    }
  }
}));

export function ErrorMessage({
  translationId,
  children,
  transform = 'capitalize'
}) {
  const classes = useStyles({ transform });
  const { formatMessage } = useIntl();
  const content = translationId
    ? formatMessage({ id: translationId })
    : children;
  return (
    <>
      <Typography variant="caption" style={{ color: 'red' }}>
        {content}
      </Typography>
    </>
  );
}

export default ErrorMessage;
